export const DRIVER_ACTIONS = {
  ACTIVATE: 'activate',
  ARCHIVE: 'archive',
  DEACTIVATE: 'deactivate',
} as const;

export type DriverAction = (typeof DRIVER_ACTIONS)[keyof typeof DRIVER_ACTIONS];
